export enum WalletButtonLabel {
  CHANGE_WALLET = "changeWallet",
  CONNECTING = "connecting",
  COPY_ADDRESS = "copyAddress",
  COPIED = "copied",
  DISCONNECT = "disconnect",
  NO_WALLET = "noWallet",
  HAS_WALLET = "hasWallet"
}
